const DD_ERROR_IDENTIFIER = "Missing event tracking properties";

export const logNotFoundTrackingProperties = (
  selectorName: string,
  module: string
) => {
  console.warn(
    `${DD_ERROR_IDENTIFIER}: ${selectorName} can't find the required properties values - Some events in ${module} might be tracking fallback properties`
  );
};
